import React, { useEffect, useState } from 'react';
import '../UserManage/User.css';
import { toast } from 'react-toastify';
import services from '../../services';
import { MultiSelect } from 'react-multi-select-component';
import { GET_ALL_USER } from '../../utils/Apifunction';

const AddUser = ({ showModal, handleClose, editData, editId, getAllGroup }) => {
    const [allUser, setAllUser] = useState([]);
    const [selectedUser, setSelectedUser] = useState(editData?.userId || []);
    const [groupName, setGroupName] = useState(editData?.name || '');

    const handleSubmit = async () => {
        const data = {
            userId: selectedUser,
            name: groupName,
        };
        try {
            const response = editId
                ? await services.group.UPDATE_GROUP(editId, data)
                : await services.group.CREATE_GROUP(data);
            setSelectedUser([]);
            setGroupName('');
            editId ? toast.success('Group Update Successfully.') : toast.success('Group Create Successfully.');
            getAllGroup();
            handleClose();
        } catch (e) {
            console.error(e);
        }
    };
    useEffect(() => {
        GET_ALL_USER_DATA();
    }, []);
    const GET_ALL_USER_DATA = async () => {
        const response = await GET_ALL_USER();
        setAllUser(
            response?.users &&
                response?.users?.length > 0 &&
                response?.users?.map((element) => ({
                    value: element?.id,
                    label: element?.name,
                })),
        );
    };
    return (
        <div>
            {showModal && (
                <div
                    className="modal fade show"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalCenterTitle"
                    aria-hidden="true"
                    style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-header">
                                <button
                                    type="button"
                                    className="close custom-close"
                                    onClick={handleClose}
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div style={{ marginTop: '0px' }}>
                                    <label className="block mb-[0.4rem] text-gray-600 text-sm font-i">Group Name</label>
                                    <input
                                        type="text"
                                        className="h-10 w-full border-r  text-gray-900 font-i focus:outline-none p-3 border-i input-border"
                                        value={groupName}
                                        onChange={(e) => {
                                            setGroupName(e.target.value);
                                        }}
                                    />
                                </div>

                                <div style={{ marginTop: '10px' }}>
                                    <label className="block mb-[0.4rem] text-gray-600 text-sm font-i">User</label>
                                    <div className="drop-header" style={{ width: '100%' }}>
                                        <MultiSelect
                                            options={allUser}
                                            value={selectedUser}
                                            onChange={(selectedOptions) => setSelectedUser(selectedOptions)}
                                            labelledBy="Select User"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleClose}>
                                    Close
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => {
                                        if (!groupName) {
                                            toast.warning('Group Name is Required');
                                            return;
                                        }

                                        handleSubmit();
                                    }}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddUser;
